import React, { useState, useEffect } from "react";
import FamilyStoryCard from "./FamilyStoryCard";
import "../stories/familystories.css";
import Navbar from '../layouts/navbar';
// import StoryCard from "./storyCard";
import Parse from 'parse';
import swal from 'sweetalert';
import {Link} from 'react-router-dom'


const FamilyStories = () => {

  const [stories, setStories] = useState([]);

  useEffect(() => {
    console.log("usefffect runn")
    var FamilyStories = Parse.Object.extend("FamilyStories");
    var query = new Parse.Query(FamilyStories);
    query.find()
    .then((stories) => {
      // The object was retrieved successfully.
      console.log("then runnn")
      console.log(stories);
      console.log(stories.id);
      setStories(stories.reverse())
    }, (error) => {
      swal("Oops!", "Seems like there is some problem with net...Please try again in sometime", "error");
      console.log(error);
      // The object was not retrieved successfully.
      // error is a Parse.Error with an error code and message.
    });

  } , []);

  return (
    <div>
      {/* <Header header=' Stories of Families' /> */}
      <Navbar head="Stories of families" />
      <div style={{marginTop:"50px"}}>
        {/* Stories */}
      {
        stories.map(story => (
          <FamilyStoryCard  story={story.get("story")} shortstory={story.get("shortstory")} youtube={story.get("youtube")} link={story.id} />
        ))
      }
      {/* <StoryCard name='Family 2' /> */}

      <button className='story btn-primary btn-lg '><Link to="/familystories/addstory">
      <i className="fas fa-plus plus"></i>Add Your Story</Link></button>
      </div>

      
    </div>
  );
}

export default FamilyStories;
